// -- 'yyyy-MM-dd' -> Date
export default function convertDateFromDateStr (date?: string): Date | undefined {
  if (!date) return undefined;
  const parts = date.split('-').map(Number);
  return !parts[0] || !parts[1] || !parts[2]
    ? undefined
    : new Date(parts[0], parts[1] - 1, parts[2]);
}